import React, { useEffect, useState } from "react";
import EmailTemplatePreview from "./Component/EmailTemplatePreview";
import Dropzone from "react-dropzone";
import InputField from "../../../component/input-field";
import ImageCrop from "./Component/ImageCrop";
import { useDispatch } from "react-redux";
import { getEmailTemplate, updateEmailTemplate } from "../../../redux/actions/company";
import { encryptData } from "../../../utils";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../component/modal-popup/customeModal";

const EmailTemplate = () => {
  const dispatch = useDispatch();
  const [applicationName, setApplicationName] = useState("");
  const [supportContact, setSupportContact] = useState("");
  const [uploadedBanner, setUploadedBanner] = useState();
  const [fileName, setFileName] = useState("");
  const [bannerUrl, setBannerUrl] = useState("");
  const [cropBanner, setCropBanner] = useState(false);
  const [removeBanner, setRemoveBanner] = useState(false);

  const getEmailTemplateData = () => {
    const request = {
      onSuccess: (res) => {
        if(res.status){
          const { email_template_app_name, email_template_banner, email_template_support } = res.data;
          setApplicationName(email_template_app_name ?? "");
          setSupportContact(email_template_support ?? "");
          setBannerUrl(email_template_banner ?? "");
        }
      },
      onError: () => {}
    }
    dispatch(getEmailTemplate(request));
  }

  useEffect(() => {
    getEmailTemplateData();
  }, [])

  const handleSave = () => {
    const formData = new FormData();
    if(uploadedBanner){
      const file = new File(uploadedBanner, fileName, { type: uploadedBanner[0].type });
      formData.append("email_template_banner", file);
    };
    if (process.env.REACT_APP_ENCRYPTION === "true") {
      const keyData = encryptData({
        email_template_app_name: applicationName?.trim(),
        email_template_support: supportContact?.trim(),
        remove_email_template_banner: removeBanner
      });
      formData.append("key", keyData.key);
    }else{
      formData.append("email_template_app_name", applicationName?.trim());
      formData.append("email_template_support", supportContact?.trim());
      formData.append("remove_email_template_banner", removeBanner);
    }   

    const request = {
      onSuccess: (res) => {
        if(res.status){
          swal({
            content: (
              <CustomeModal
                type="success"
                title="Success!"
                content={`Email template successfully updated.`}
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
          getEmailTemplateData();
          setUploadedBanner();
          setFileName();
        }        
      },
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Something went wrong. Please try again later."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      }
    }
    dispatch(updateEmailTemplate(formData, request));
  }

  return (
    // flex-auto bg-white max-h-full w-full space-y-8 relative mt-3
    <>
      <div className="w-full max-h-full relative mt-3 bg-white grid grid-cols-1 lg:grid-cols-2 gap-5">
        <div className="space-y-5">
          <p className="font-inter font-semibold text-base text-[#1E293B]">
            Email Banner
          </p>
          <div className="w-full flex flex-col justify-center space-y-4">
            <div className="w-full space-y-3">
              <div>
                <Dropzone
                  accept={{
                    "image/*": [], // Accepts all image formats
                  }}
                  multiple={false}
                  onDrop={(acceptedFiles) => {
                    setUploadedBanner(acceptedFiles);
                    setFileName(acceptedFiles[0].name);
                    setRemoveBanner(false);
                    setCropBanner(true);
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <section className="border-2 border-dashed border-[#94A3B8] h-[140px] flex justify-center items-center bg-white rounded-lg">
                      <div {...getRootProps()}>
                        <input {...getInputProps()} />
                        <div className="space-y-2">
                          {uploadedBanner?.length > 0 ? (
                            <div className="w-full h-full text-center relative">
                              <img
                                src={URL.createObjectURL(uploadedBanner[0])}
                                alt="uploadedLogo"
                                className="w-full h-[120px] object-cover"
                              />
                              <div className="absolute top-0 -right-10 space-x-1">
                                <span
                                  class="fa-solid fa-square-x text-rose-500 cursor-pointer"
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    setUploadedBanner();
                                    setFileName();
                                  }}
                                ></span>
                              </div>
                            </div>
                          ) : bannerUrl ? (
                            <div className="w-full h-full text-center relative">
                              <img
                                src={bannerUrl}
                                alt="uploadedLogo"
                                className="w-full h-[120px] object-cover"
                              />
                              <div className="absolute top-0 -right-10 space-x-1">
                                <span
                                  class="fa-solid fa-square-x text-rose-500 cursor-pointer"
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    setBannerUrl();
                                    setRemoveBanner(true);
                                  }}
                                ></span>
                              </div>
                            </div>
                          ) : (
                            <>
                              <span class="fa-light fa-arrow-up-from-bracket text-2xl font-normal block text-center"></span>
                              <h4 className="text-sm text-[#94A3B8] font-medium">
                                Drop your banner here or
                              </h4>
                              <div className="flex justify-center">
                                <button className="btn !border !border-[--bg-color-500] text-[--bg-color-500] flex justify-center">
                                  Browse Files
                                </button>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </section>
                  )}
                </Dropzone>
              </div>
            </div>
            <InputField
              type="text"
              label="Application Name"
              placeholder="Enter Application Name"
              value={applicationName}
              onChange={(e) => {
                setApplicationName(e.target.value);
              }}
            />
            <InputField
              type="text"
              label="Application Support Contact"
              placeholder="Enter Application Support Contact"
              value={supportContact}
              onChange={(e) => {
                setSupportContact(e.target.value);
              }}
            />
          </div>
        </div>
        <div>
          <EmailTemplatePreview
            applicationName={applicationName}
            supportContact={supportContact}
            uploadedBanner={uploadedBanner?.length > 0 ? URL?.createObjectURL(uploadedBanner[0]) : bannerUrl}
          />
        </div>
      </div>
      <div className="py-4 flex justify-end">
        <button
          className="btn bg-[--bg-color-500] text-white hover:bg-[--bg-color-600] cursor-pointer"
          onClick={(e) => {
            e.stopPropagation();
            handleSave();
          }}
        >
          Update Configuration
        </button>
      </div>
      <ImageCrop
        modalOpen={cropBanner}
        setModalOpen={setCropBanner}
        uploadedImage={uploadedBanner}
        setUploadedImage={setUploadedBanner}
      />
    </>
  );
};

export default EmailTemplate;
